import { LngLat } from 'domain/types/location/coordinates';
import { CreateProjectRequest } from 'state/services/backend/types/project/request';

export const createProjectName = (address: string, cantonAbbr: string) => {
  let name;
  if (!address) {
    name = `Ausgewählter Ort (${cantonAbbr})`;
  } else {
    const addr = address.split(' ');
    name = `${addr[0]} `;
    let hasReachedNumber = false;
    for (let i = 1; i < addr.length; i++) {
      if (!hasReachedNumber) {
        const newPart = addr[i].replace(/,/g, '');
        // @ts-ignore
        if (isNaN(newPart)) name += `${newPart} `;
        else {
          name += `${newPart}`;
          hasReachedNumber = true;
        }
      }
    }
  }
  return name;
};

export interface CreateProjectDtoProps {
  address: string;
  area: number;
  cantonAbbr: string;
  egrids: string[];
  isPlotSaveAction?: boolean;
  lngLat: LngLat;
  plotNumber: string;
  polygon: number[][];
  selectedZoneId: number | null;
}

export const createProjectDto = (props: CreateProjectDtoProps): CreateProjectRequest => {
  const { address, lngLat, selectedZoneId, egrids, plotNumber, isPlotSaveAction, cantonAbbr, polygon, area } = props;

  const location: CreateProjectRequest['location'] = {
    center: lngLat,
    address,
    plot: {
      plotNumber,
      egrid: egrids[0],
      polygon,
      area,
    },
  };

  const name = createProjectName(address, cantonAbbr);

  return {
    name,
    egrids,
    location,
    selectedZoneId,
    isPlotSaveAction,
  };
};
